export default __webpack_public_path__ + "696361b1624657ece1152b09cd120f66.png";